import { PayloadAction, createAction, createSlice } from "@reduxjs/toolkit";

const clearAction = createAction("clear");

export interface YouTubeConsentState {
  hasConsented: boolean;
}

const initialState: YouTubeConsentState = {
  hasConsented: false,
};

const youtubeConsentSlice = createSlice({
  name: "youtubeConsent",
  initialState,
  reducers: {
    setYouTubeConsent: (state, action: PayloadAction<boolean>) => {
      state.hasConsented = action.payload;
    },
    clearYouTubeConsent: (state) => {
      state.hasConsented = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(clearAction, () => initialState);
  },
});

export const { setYouTubeConsent, clearYouTubeConsent } = youtubeConsentSlice.actions;
export default youtubeConsentSlice.reducer;